"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
function Icon(props) {
    const size = props.size ? props.size + "px" : "24px";
    let fill = props.htmlColor || "#4E5C6E";
    if (props.light)
        fill = "#FFF";
    if (props.black)
        fill = "#000";
    const { isNotMui } = props, propsCopy = __rest(props, ["isNotMui"]);
    const { light, black } = propsCopy, muiProps = __rest(propsCopy, ["light", "black"]);
    const { fontSize, shapeRendering, titleAccess, sx } = propsCopy, nonMuiProps = __rest(propsCopy, ["fontSize", "shapeRendering", "titleAccess", "sx"]);
    return props.isNotMui ? (React.createElement(material_1.SvgIcon, Object.assign({}, nonMuiProps, { style: { fill: fill, width: size, height: size } }), props.children)) : (React.createElement(material_1.SvgIcon, Object.assign({}, muiProps), props.children));
}
exports.default = Icon;
